// AI-CONTEXT: See docs/features/update-aanvragen.md
// De bovenliggende tabbladen van de Updates-pagina: wat er nieuw is, en het
// aanvragen van een update. Los van de modulefilterrij (buildUpdateTabs.js),
// die alleen bínnen 'Wat is er nieuw' staat — dat zijn twee verschillende
// soorten keuze en ze horen niet in één rij.

/**
 * @typedef {object} UpdatePageTab
 * @property {string} slug - Waarde in de URL en in de vergelijking
 * @property {string} label - Wat op het tabblad staat
 */

const TAB_NIEUW = 'nieuw'
const TAB_AANVRAGEN = 'aanvragen'
const TAB_MIJN_UPDATES = 'mijn-updates'

/** Het URL-onderdeel waarmee je rechtstreeks op een tabblad landt. */
const UPDATE_PAGE_TAB_PARAM = 'tab'

/**
 * Alleen panelen die er echt zijn. Een tabblad zonder inhoud is een doodlopend
 * pad, dus deze lijst groeit pas mee als het paneel gebouwd is.
 *
 * @type {Array<UpdatePageTab>}
 */
const UPDATE_PAGE_TABS = [
    { slug: TAB_NIEUW, label: 'Wat is er nieuw' },
    { slug: TAB_AANVRAGEN, label: 'Update aanvragen' },
    { slug: TAB_MIJN_UPDATES, label: 'Mijn updates' },
]

const DEFAULT_UPDATE_PAGE_TAB = TAB_NIEUW

/**
 * Vertaalt de waarde uit de URL naar een tabblad dat echt bestaat.
 *
 * Valt bewust dicht terug op het eerste tabblad in plaats van een leeg scherm
 * te tonen: een oude link, een typefout of een notificatie die naar een later
 * gebouwd tabblad wijst mag de pagina niet leeg achterlaten.
 *
 * @param {*} slug - Ruwe waarde uit de querystring
 * @returns {string} Een slug die in UPDATE_PAGE_TABS voorkomt
 */
const resolveUpdatePageTab = (slug) => (
    UPDATE_PAGE_TABS.some(tab => tab.slug === slug) ? slug : DEFAULT_UPDATE_PAGE_TAB
)

export {
    UPDATE_PAGE_TABS,
    DEFAULT_UPDATE_PAGE_TAB,
    UPDATE_PAGE_TAB_PARAM,
    TAB_NIEUW,
    TAB_AANVRAGEN,
    TAB_MIJN_UPDATES,
}

export default resolveUpdatePageTab
